// extracted by mini-css-extract-plugin
module.exports = {"flex":"Search_flex__r-nWn","searchIcon":"Search_searchIcon__o-iLj"};